import { GenIcon } from '../helpers/IconBase.es.js';

const ScanningOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6 4.75C5.30964 4.75 4.75 5.30964 4.75 6V7.34375C4.75 7.75797 4.41421 8.09375 4 8.09375C3.58579 8.09375 3.25 7.75797 3.25 7.34375V6C3.25 4.48122 4.48122 3.25 6 3.25H7.34375C7.75797 3.25 8.09375 3.58579 8.09375 4C8.09375 4.41421 7.75797 4.75 7.34375 4.75H6ZM15.7391 4C15.7391 3.58579 16.0749 3.25 16.4891 3.25H17.8328C19.3516 3.25 20.5828 4.48122 20.5828 6V7.34375C20.5828 7.75797 20.247 8.09375 19.8328 8.09375C19.4186 8.09375 19.0828 7.75797 19.0828 7.34375V6C19.0828 5.30964 18.5232 4.75 17.8328 4.75H16.4891C16.0749 4.75 15.7391 4.41421 15.7391 4ZM20.5828 16.4893C20.5828 16.075 20.247 15.7393 19.8328 15.7393C19.4186 15.7393 19.0828 16.075 19.0828 16.4893V17.833C19.0828 18.5234 18.5232 19.083 17.8328 19.083H16.4891C16.0749 19.083 15.7391 19.4188 15.7391 19.833C15.7391 20.2472 16.0749 20.583 16.4891 20.583H17.8328C19.3516 20.583 20.5828 19.3518 20.5828 17.833V16.4893ZM4 15.7393C4.41421 15.7393 4.75 16.075 4.75 16.4893V17.833C4.75 18.5234 5.30964 19.083 6 19.083H7.34375C7.75797 19.083 8.09375 19.4188 8.09375 19.833C8.09375 20.2472 7.75797 20.583 7.34375 20.583H6C4.48122 20.583 3.25 19.3518 3.25 17.833V16.4893C3.25 16.075 3.58579 15.7393 4 15.7393ZM3 11.25C2.58579 11.25 2.25 11.5858 2.25 12C2.25 12.4142 2.58579 12.75 3 12.75H21C21.4142 12.75 21.75 12.4142 21.75 12C21.75 11.5858 21.4142 11.25 21 11.25H3Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { ScanningOutlined };
